import { render, staticRenderFns } from "./Heartbeat.vue?vue&type=template&id=23c644b4&"
import script from "./Heartbeat.vue?vue&type=script&lang=js&"
export * from "./Heartbeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports